"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuoteStyled = exports.ScriptStyled = exports.HeadStyled = exports.StyledBox = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("@dbi-tools/ui-kit/lib/const");

var _styled = require("../../styled");

var _helpers = require("../../helpers");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: ", ";\n  min-height: ", "px;\n  margin: 0 15px;\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 -15px;\n    padding: 15px;\n\n    ", " {\n      margin: 0 10px;\n    }\n\n    ", " {\n      color: ", ";\n      a {\n        color: ", ";\n      }\n    }\n    ", " {\n      color: ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  text-align: ", ";\n  color: ", ";\n  margin-top: 10px;\n  font-weight: normal !important;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  text-align: ", ";\n  color: ", ";\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n  & > img {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
});
exports.StyledBox = StyledBox;
var HeadStyled = (0, _uiKit.styled)('h3')(_templateObject2(), _styled.Line1Styles, function (_ref2) {
  var align = _ref2.align;
  return align || 'left';
}, function (_ref3) {
  var color = _ref3.color;
  return color || 'gray800';
});
exports.HeadStyled = HeadStyled;
var ScriptStyled = (0, _uiKit.styled)('h2')(_templateObject3(), _styled.Line2Styles, function (_ref4) {
  var align = _ref4.align;
  return align || 'left';
}, function (_ref5) {
  var color = _ref5.color;
  return color || 'gray800';
});
exports.ScriptStyled = ScriptStyled;

var bgStyles = function bgStyles(colorContrast) {
  return (0, _uiKit.css)(_templateObject4(), _const.GridBreakpointsMediaDown.sm, HeadStyled, colorContrast, colorContrast, ScriptStyled, colorContrast);
};

var QuoteStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject5(), function (_ref6) {
  var alignItems = _ref6.alignItems;
  return alignItems;
}, function (_ref7) {
  var height = _ref7.height;
  return height;
}, function (_ref8) {
  var isBackgroundOn = _ref8.isBackgroundOn,
      colorContrast = _ref8.colorContrast;
  return isBackgroundOn && bgStyles(colorContrast);
});
exports.QuoteStyled = QuoteStyled;